import { render, staticRenderFns } from "./vr-course.vue?vue&type=template&id=21e633ed&scoped=true&"
import script from "./vr-course.vue?vue&type=script&lang=js&"
export * from "./vr-course.vue?vue&type=script&lang=js&"
import style0 from "./vr-course.vue?vue&type=style&index=0&id=21e633ed&lang=scss&scoped=true&"
import style1 from "./vr-course.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e633ed",
  null
  
)

export default component.exports